import type { QuotaPolicy } from '@cca/xero-shared';

// A short, plain-English summary of a policy's settings. Used to PRE-FILL the
// note on a saved policy (the registrar can then edit or extend it). Mirrors the
// smoothing wording used in PolicyForm: 0–1 years = a single year, otherwise an
// N-year rolling average, optionally anchored to a basis year.

const money = (n: number) => `$${Math.round(n).toLocaleString('en-NZ')}`;
/** Percentages shown to at most 1 decimal place. */
const pct1 = (x: number) => Math.round(x * 10) / 10;

export function describePolicy(p: QuotaPolicy): string {
  const parts: string[] = [];

  const { years, basis_year } = p.smoothing;
  if (years <= 1) {
    parts.push(basis_year ? `single year ${basis_year}` : 'single year');
  } else {
    parts.push(basis_year ? `${years}-yr avg to ${basis_year}` : `${years}-yr avg`);
  }

  if (p.base_exclusion && p.base_exclusion > 0) parts.push(`base excl ${money(p.base_exclusion)}`);

  parts.push(`${p.bands.length} band${p.bands.length === 1 ? '' : 's'}`);
  parts.push(`floor ${money(p.floor)}`);

  if (p.cap.cap_amount != null) parts.push(`cap ${money(p.cap.cap_amount)}`);
  if (p.cap.cap_pct_of_assessable != null)
    parts.push(`cap ${pct1(p.cap.cap_pct_of_assessable * 100)}%`);
  if (p.yoy_increase_cap != null) parts.push(`yoy +${pct1(p.yoy_increase_cap * 100)}%`);
  if (p.collar) parts.push('collar');

  if (p.phase_in.enabled && p.phase_in.schedule.length)
    parts.push(`phase-in ${p.phase_in.schedule.join('/')}`);

  return parts.join(' · ');
}
